import React from "react";
import "../App.css";

export default function WineSection({
  imageSrc = "/assets/gallery/cave.jpg",
  imageAlt = "Cave à vin",
  titreSection = "Cave à vins",
  titre = "Service des vins",
  texte = [
    "Les vins de notre cave peuvent être savourés sur place ou achetés à emporter.",
    "Pour toute bouteille consommée sur place, un droit de bouchon de 15 € / 75 cl s’applique.",
    "Nous proposons également une sélection raffinée de spiritueux, disponibles au verre.",
  ],
  cavisteNom = "Hugues Wautelet",
  cavisteTexte = ", caviste passionné et ami de longue date du Chef, sélectionne avec soin chaque bouteille pour sublimer la carte. À travers sa boutique Aux Sens Larges, il partage son amour des vins et des spiritueux d’exception.",
  cavisteUrl = "https://www.auxsenslarges.be/",
}) {
  return (
    <section className="wine-section section-padding" id="vins">
      {/* Conteneur titre */}
      <div className="wine-title-container section-padding text-center">
        <h2 className="card-surface text-4xl font-serif font-bold text-primary text-center wine-title">
          {titreSection}
        </h2>
      </div>

      {/* Conteneur principal */}
      <div className="wine-container">
        {/* Colonne image (gauche) */}
        <div className="wine-image">
          <img src={imageSrc} alt={imageAlt} loading="lazy" />
        </div>

        {/* Colonne contenu (droite) */}
        <div className="wine-content">
          <div className="wine-description card-surface">
            <h3 className="caviste-title">{titre}</h3>
            <p>
              {texte.map((ligne, index) => (
                <React.Fragment key={index}>
                  {index === 1 ? (
                    <>
                      Pour toute bouteille consommée sur place, un droit de
                      bouchon de{" "}
                      <span className="nowrap">
                        15&nbsp;€&nbsp;/&nbsp;75&nbsp;cl
                      </span>{" "}
                      s’applique.
                    </>
                  ) : (
                    ligne
                  )}
                  {index < texte.length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>
          </div>

          <div className="caviste-card card-surface">
            <div className="caviste-header">
              <h4 className="caviste-title">Notre caviste</h4>
            </div>
            <p className="caviste-text">
              <strong className="text-primary">{cavisteNom}</strong>
              <span className="text-black">{cavisteTexte}.</span>
            </p>

            <a
              className="btn-primary"
              href={cavisteUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Découvrir le site du caviste : ${cavisteNom}`}
            >
              Découvrir le site du caviste
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
